import httpClient from "../axiosBase/axiosHandler";

/**
 * Fetch a fresh Centrifuge WebSocket token from the server.
 * Used on page refresh (when wsCredentials are not in Redux) and
 * internally by the Centrifuge getToken callback when the token expires.
 *
 * Response shape:
 *   { data: { token: string, socket_url: string } }
 */
export const getRealtimeWsToken = () =>
  httpClient.post("/realtime/ws/token/", {});
